import type { SharedOrder } from "@shared/types/Order";

export enum OrderMessagingType {
  MESSAGE_REP_BUTTON,
  MESSAGE_LIST,
  NONE,
}

export const showOrderMessaging = (order: SharedOrder): OrderMessagingType => {
  if (order.distributor.no_rep_notifications) {
    return OrderMessagingType.NONE;
  } else if (!order.distributor.integrated) {
    return OrderMessagingType.MESSAGE_LIST;
  } else {
    return OrderMessagingType.MESSAGE_REP_BUTTON;
  }
};
